import './ValidationSummary.css';

export default function ValidationSummary({ summary }) {
  return (
    <div className="validation-summary">
      <div className="summary-card">
        <div className="icon">⏳</div>
        <div>
          <p>Plans en attente</p>
          <h3>{summary.pending}</h3>
          <span>Nouveaux plans à évaluer</span>
        </div>
      </div>
      <div className="summary-card">
        <div className="icon">✅</div>
        <div>
          <p>Validations complétées</p>
          <h3>{summary.completed}</h3>
          <span>Ce mois-ci</span>
        </div>
      </div>
      <div className="summary-card">
        <div className="icon">📝</div>
        <div>
          <p>À réviser</p>
          <h3>{summary.revise}</h3>
          <span>Plans nécessitant des ajustements</span>
        </div>
      </div>
    </div>
  );
}
